module.exports = __webpack_public_path__ + "img/plus_btn.e238c3fe.png";